// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

import wixLocation from 'wix-location';
import wixData from 'wix-data';

// ID of the currently selected tool type
let selectedType;

$w.onReady(function () {
	let type = wixLocation.query.type;
	if (type) {
		selectedType = type;
		updateFilter()
	}
});

export function expandTool_click(event) {
	let $item = $w.at(event.context);
	$item('#expandTool').hide();
	$item('#extendedTool').expand();
	$item('#collapseTool').show();
}

export function collapseTool_click(event) {
	let $item = $w.at(event.context);
	$item('#collapseTool').hide();
	$item('#extendedTool').collapse();
	$item('#expandTool').show();
}


export function toolTypesRepeater_itemReady($item, itemData, index) {
	if (selectedType === itemData._id) {
		// preselect the button if the type was set via query
		$item('#toolTypeButton').style.backgroundColor = '#FBD1A3';
	}
	$item('#toolTypeButton').onClick(()=>{
		if (selectedType === itemData._id) {
			// deselect and remove the filter
			$item('#toolTypeButton').style.backgroundColor = 'white';
			selectedType = undefined;
		} else {
			// change the selected type to the clicked button
			$w('#toolTypesRepeater').forEachItem(($i)=>{
				$i('#toolTypeButton').style.backgroundColor = 'white';
			})
			$item('#toolTypeButton').style.backgroundColor = '#FBD1A3';
			selectedType = itemData._id;
		}
		updateFilter()
	});
	if (itemData.url) {
		$item('#iconButton1').expand()
	}
}

function updateFilter() {
	let filter = wixData.filter();
	if (selectedType) {
		filter = filter.eq('type', selectedType)
	}
	$w('#toolsDataset').setFilter(filter);
}

export function repeater4_itemReady($item, itemData, index) {
	if (itemData.youtube) {
		$item('#videoPlayer1').expand()
	}
	if (itemData.doc) {
		$item('#iconButton2').expand();
		if (itemData.docTitle) {
			$item('#text12').expand()
		}
	}
	if (itemData.url) {
		$item('#iconButton1').expand()
	}
	if (itemData.type) {
		$item('#text8').expand()
	}
}